export enum UserType {
    TPA = 1,
    Provider = 2,
    Payer = 3,
    Patient = 4
}

export enum UserTypeName {
    TPA = 'TPA',
    Provider = 'Provider',
    Payer = 'Payer',
    Patient = 'Patient'
}

export const UserTypeLabel: { [key in UserType]: string } = {
    [UserType.TPA]: 'COMMON.TPA',
    [UserType.Provider]: 'PROVIDER.TITLE',
    [UserType.Payer]: 'INSURANCE_COMPANY.TITLE',
    [UserType.Patient]: 'PATIENT_PORTAL.TITLE'
};